import { StyleSheet } from 'react-native';
import theme from '@/config/theme';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  flex1: {
    flex: 1,
  },
  flex1Square: {
    flex: 1,
    aspectRatio: 1,
  },
  flex1Row: {
    flex: 1,
    flexDirection: 'row',
  },
  flex2: {
    flex: 2,
  },
  flex1Center: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  flex1End: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'flex-end',
    width: '100%',
  },
  flex1CenterFull: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  flex1JustifyEnd: {
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  flex1MarginRight: {
    flex: 1,
    marginRight: theme.spacings.lg,
  },
  flex1PaddingH: {
    flex: 1,
    paddingHorizontal: theme.spacings.lg,
  },
  fullRow: {
    height: '100%',
    width: '100%',
    flexDirection: 'row',
  },
  width2thirds: {
    width: '66.66%',
  },
  width1thirdCenter: {
    width: '33.33%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  maxH500: {
    maxHeight: 500,
    width: '100%',
    height: '100%',
  },
  maxH300: {
    maxHeight: 300,
    width: '100%',
    height: '100%',
  },
  maxH300Bottom: {
    maxHeight: 300,
    width: '100%',
    height: '100%',
    bottom: theme.spacings.xs,
  },
  exerciseText: {
    fontFamily: theme.fontFamilies.exerciseFont,
  },
  container: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  textBodyContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    height: '70%',
    width: '90%',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.23,
    shadowRadius: 2.62,
    elevation: 4,
    backgroundColor: colors.white,
  },
  bodyContainer: {
    width: '100%',
    alignItems: 'center',
    padding: 10,
  },
  buttonsContainer: {
    width: '90%',
    justifyContent: 'space-between',
    marginVertical: 20,
  },
  weiterContainer: {
    alignItems: 'center',
  },
  flexContainer: {
    flex: 1,
  },
  row: {
    flexDirection: 'row',
  },
  playerContainer: {
    flex: 1,
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  miniPlayerContainer: {
    flex: 2,
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
